import { combineDucks } from "lib/utils/duck";

import ProductsListView from "./ProductsListView";
import EditProductView from "./EditProductView";
import utils from "./utils";

export default combineDucks({
  ProductsListView,
  EditProductView,
  utils,
});



// WEBPACK FOOTER //
// ./src/modules/products/index.js